import { getAffiliateCookieData } from './affiliateCookie';
import { getMetaPartner } from './meta/metaPartnerRegistry';

export function isTrivagoAffiliateInUrlOrCookie(): boolean {
  const urlParams = new URL(window.location.href).searchParams;
  const affiliateId =
    urlParams.get('affiliate-id') ??
    getAffiliateCookieData()?.affiliateCookieParams.AffiliateId;
  return getMetaPartner({ affiliateId }) === 'trivago';
}

export function isTrivagoAffiliateInURL(): boolean {
  const affiliateId = new URL(window.location.href).searchParams.get(
    'affiliate-id'
  );
  return getMetaPartner({ affiliateId }) === 'trivago';
}
